/**
 * Feature flag for the hybrid keyword+vector search on All Stories.
 *
 * Default: ON. The search UI is in design review on this branch, so
 * Vercel previews must show it without per-deploy env-var configuration.
 * Override with `NEXT_PUBLIC_EXPLORE_SEARCH_ENABLED`:
 *   - "true"  → force on (redundant with default but explicit)
 *   - "false" → force off
 *   - unset   → on
 *
 * `NEXT_PUBLIC_*` is required so this resolves consistently on both the
 * server and the client (the input renders inside a "use client" tree).
 */
export function isExploreSearchEnabled(): boolean {
  const flag = process.env.NEXT_PUBLIC_EXPLORE_SEARCH_ENABLED;
  if (flag === "false" || flag === "0") {
    return false;
  }
  return true;
}
